<tt-page *ngIf="!!setting">
    <div *ngIf="'mobile' | mediaQuery">
        <tt-card class="col-xs-12 p-5">
            <tt-select *ngIf="setting.active_deliverymethod_no === '0'" ttRememberId="cd_deliverymethod_no" ttLabel="driver" [(ttModel)]="deliveryMethodNo" (ttModelChange)="onChanged($event, 'deliveryMethodNo')" [ttData]="selectListDeliveryMethods" ttDataId="item_id" ttDataName="item_name"></tt-select>

            <tt-tabs [(ttSelectedId)]="selectedBgConsignmentDelivery" (ttSelectedIdChange)="onTabChanged()">
                <tt-tab ttId="active" ttLabel="active"></tt-tab>
                <tt-tab ttId="delivered" ttLabel="delivered"></tt-tab>
            </tt-tabs>
        </tt-card>

        <tt-list *ngIf="!tabletMediaQuery.matches" [hidden]="deliveryMethodNo === '0'" class="col-xs-12 p-5" [ttData]="itemsListConsignmentDeliveries"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5" *ngIf="setting.active_deliverymethod_no === '0'">
            <tt-select ttRememberId="cd_deliverymethod_no" ttLabel="driver" [(ttModel)]="deliveryMethodNo" (ttModelChange)="onChanged($event, 'deliveryMethodNo')" [ttData]="selectListDeliveryMethods" ttDataId="item_id" ttDataName="item_name"></tt-select>
        </tt-card>

        <tt-divider ttRememberId="consignmentdelivery_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" ttHeading="active" ttTranslate></tt-card>
                    <tt-list *ngIf="tabletMediaQuery.matches" [hidden]="deliveryMethodNo === '0'" class="col-xs-12 p-5" [ttData]="itemsListConsignmentDeliveriesActive"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" ttHeading="delivered" ttTranslate></tt-card>
                    <tt-list *ngIf="tabletMediaQuery.matches" [hidden]="deliveryMethodNo === '0'" class="col-xs-12 p-5" [ttData]="itemsListConsignmentDeliveriesDelivered"></tt-list>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
